import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../../apiCall';
import { baseUrl, customHeaders, uaeProjectsBaseURL } from './../../../../../Containers/Config/index';

import { UPDATE_CATEGORY, UPDATE_CATEGORY_SUCCESS, UPDATE_CATEGORY_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* updateCategory({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/categories`,
      method: 'PUT',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({ type: UPDATE_CATEGORY_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: UPDATE_CATEGORY_ERROR, payload: response.error });
    }
  } catch (error) {
    yield put({ type: UPDATE_CATEGORY_ERROR, payload: error });
  }
}

export function* watchUpdateCategory() {
  yield takeEvery(UPDATE_CATEGORY, updateCategory);
}

function* updateCategorySaga() {
  yield all([fork(watchUpdateCategory)]);
}

export default updateCategorySaga;
